<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="mb-0">
      <i class="bi bi-building text-warning me-2"></i>{{ 'admin.clients.list_title' | translate }}
    </h4>
    <button class="btn btn-accent" (click)="addClient()">
      <i class="bi bi-plus me-2"></i>{{ 'admin.clients.new' | translate }}
    </button>
  </div>

  <div class="card">
    <div class="card-body">
      <s-table [cols]="tab.cols" [refreshUrl]="tab.refreshUrl"
        [detailUrl]="tab.detailUrl" [detailId]="tab.detailId"
        [showPageSize]="!shared.isMobileConst">
      </s-table>
    </div>
  </div>
</div>
